<template>
    <div>
        <div class="photo-album-item" >
        <Row :gutter="16" >
        <Col span="6">
        <div class="img img-s">
            <img :src="list && list.length && list[0].imgSrc" alt="">
        </div>
        <div class="img img-s">
            <img :src="list && list.length && list[1].imgSrc" alt="">
        </div>
        </Col>
        <Col span="6">
        <div class="img img-s">
            <img :src="list && list.length && list[2].imgSrc" alt="">
        </div>
        <div class="img img-s">
            <img :src="list && list.length && list[3].imgSrc" alt="">

        </div>
        </Col>
        <Col span="6">
        <div class="img img-h">
            <img :src="list && list.length && list[4].imgSrc" alt="">

        </div>
        </Col>
        <Col span="6">
        <div class="img img-h">
            <img :src="list && list.length && list[5].imgSrc" alt="">

        </div>
        </Col>
        </Row>
        <Row :gutter="16">
        <Col span="6">
        <div class="img img-h">
            <img :src="list && list.length && list[6].imgSrc" alt="">

        </div>
        </Col>
        <Col span="6">
        <div class="img img-h">
            <img :src="list && list.length && list[7].imgSrc" alt="">

        </div>
        </Col>
        <Col span="6">
        <div class="img img-s">
            <img :src="list && list.length && list[8].imgSrc" alt="">

        </div>
        <div class="img img-s">
            <img :src="list && list.length && list[9].imgSrc" alt="">

        </div>
        </Col>
        <Col span="6">
        <div class="img img-h">
            <img :src="list && list.length && list[10].imgSrc" alt="">

        </div>
        </Col>
        </Row>
        </div>

    </div>
</template>
<script>
    export default {
        props:{
            list:{
                type:Array ||Object,
                default(){
                    return []
                }
            }
        },
        data () {
            return {
            }
        },
        mounted(){
            var self = this;
        },
        computed:{

        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
    .img{
        overflow: hidden;
        margin-bottom: 20px;
        >img{
            width: 100%;
            height: 100%;
        }
        &.img-h{
            width: 244px;
            height: 300px;
        }
        &.img-s{
            width: 244px;
            height: 140px;
        }
    }

</style>